<template>
  <form v-if="loaded">
    <div>
      <vue-form-generator :model="form" :options="formOptions" :schema="schema"></vue-form-generator>
    </div>
    <button id="save" data-test="save" class="btn btn-primary btn-block" @click.prevent="submit">
      {{ $t('network.user.save') }}
    </button>
    <div class="row">
      <div v-if="saving" class="text-center">
        <lottie-player
          autoplay
          loop
	        speed="2.5"
          src="/img/animations/custom_loader.json"
          style="height: 80px;"
          >
        </lottie-player>
        <p>{{ $t('saving') }}</p>
      </div>
      <div v-if="saved">
        <div class="alert alert-success alert-dismissible mt-4 mb-0" role="alert">
          <i class="fas fa-check"></i>
          {{ $t('ResearchCreds.your-information-was-saved') }}
          <button id="close" data-test="close" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </form>
  <div v-else class="row text-center mt-5">
    <lottie-player
      autoplay
      loop
	    speed="2.5"
      src="/img/animations/custom_loader.json"
      style="height: 130px;"
      >
    </lottie-player>
  </div>
</template>
<script>
import '@/lib/vue-form-generator';
import { baseName } from '@/lib/util.js';

export default {
  data() {
    return {
      loaded: false,
      saving: false,
      saved: false,
      otherCategoryID: 0,
      categories: [],
      form: {},
      schema: {},
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  computed: {
    countries() {
      return this.$store.getters['countries'];
    },
    states() {
      return this.$store.getters['states'];
    },
  },
  created() {
    this.$store.dispatch('loadCountries');
    this.$store.dispatch('loadStates');
  },
  mounted() {
    this.getWorkinfoProfile();
  },
  methods: {
    submit() {
      if (this.form.country == '193') {
        this.form.city = this.form.state;
      }
      if (this.form.country == null || this.form.country == '') {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('network.auth.workplace_country') + ' is required',
        }).then(() => {
          return;
        });
      } else if (this.form.city == null || this.form.city == '') {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('network.auth.workplace_city') + ' is required',
        }).then(() => {
          return;
        });
      } else {
        this.save().then(() => this.$emit('submitted'));
      }
    },
    save() {
      this.saving = true;
      this.form.cv_filename = baseName(this.form.cv_file);

      return this.axios.post('profile/workinfo', this.form).then(() => {
        this.saving = false;
        this.saved = true;
        this.$store.dispatch('resetUserWorkInfo', this.form);
        this.$bus.emit('profile-progress-submit');
      });
    },
    getWorkinfoProfile() {
      this.$http.get('profile/workinfo').then(response => {
        this.form = response.data.model;
        let displayedFields = ['employment_status', 'workplace', 'job_title', 'job_category_id', 'job_category_other', 'workplace_address', 'country', 'city', 'state', 'cv_file', 'cv_file_last_update_date'];
        this.form.cv_filename = baseName(response.data.model.cv_file);
        this.categories = response.data.categories;
        this.otherCategoryID = response.data.otherCategoryID;
        this.buildSchema();
        this.loaded = true;
        this.$nextTick(() => {
          for (let key in this.form) {
            if ((this.form[key] == null || this.form[key] === '') && displayedFields.includes(key)) {
              this.addBorder(key);
            }
          }
        });
      });
    },
    getElementId(value) {
      const elementIds = {
        'employment_status': 'your-employment-status',
        'workplace': 'workplacehospitaluniversityorganization',
        'job_title': 'your-job-title',
        'job_category_id': 'what-is-your-job-category',
        'job_category_other': 'job-category-description',
        'workplace_address': 'workplace-address',
        'country': 'country--region-workplacesup-classtext-danger-ms-1sup',
        'city': 'city-workplacesup-classtext-danger-ms-1sup',
        'state': 'state-workplacesup-classtext-danger-ms-1sup',
        'cv_file': 'cv-file',
        'cv_file_last_update_date': 'when-was-the-cv-last-updated',
      };
      return elementIds[value] || null;
    },
    addBorder(value) {
      const elementId = this.getElementId(value);
      const element = document.getElementById(elementId);
      if (element) {
        element.classList.add('border-2', 'border-info');
      }
    },
    removeBorder(value) {
      const elementId = this.getElementId(value);
      const element = document.getElementById(elementId);
      if (element) {
        element.classList.remove('border-2', 'border-info');
      }
    },
    buildSchema() {
      this.schema = {
        groups: [
          {
            fields: [
              {
                type: 'select',
                selectOptions: {
                  noneSelectedText: this.$t('select-your-employment-status'),
                },
                label: this.$t('auth.workinfo.employment_status'),
                model: 'employment_status',
                //required: true,
                values: [
                  { id: 'full_time', name: this.$t('Workinfo.full-time') },
                  { id: 'part_time', name: this.$t('Workinfo.part-time') },
                  { id: 'contract', name: this.$t('Workinfo.contract') },
                ],
                styleClasses:'column pe-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('employment_status');
                  } else {
                    this.removeBorder('employment_status');
                  }
                },
              },
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('auth.workinfo.workplace'),
                placeholder: this.$t('enter-name-of-your-workplace-hospital-university-organization'),
                model: 'workplace',
                styleClasses:'column ps-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('workplace');
                  } else {
                    this.removeBorder('workplace');
                  }
                },
              },
            ],
          },
          {
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('auth.workinfo.job_title'),
                placeholder: this.$t('enter-your-job-title'),
                model: 'job_title',
                styleClasses:'column pe-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('job_title');
                  } else {
                    this.removeBorder('job_title');
                  }
                },
              },
              {
                type: 'select',
                selectOptions: {
                  noneSelectedText: this.$t('select-your-job-category'),
                },
                label: this.$t('Investigator.what-is-your-job-category'),
                model: 'job_category_id',
                values: this.categories,
                styleClasses:'column ps-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('job_category_id');
                  } else {
                    this.removeBorder('job_category_id');
                  }
                },
              },
            ],
          },
          {
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('Investigator.job-category-description'),
                placeholder: this.$t('enter-your-job-category-description'),
                model: 'job_category_other',
                styleClasses:'column pe-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('job_category_other');
                  } else {
                    this.removeBorder('job_category_other');
                  }
                },
              },
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('ModerationTab.workplace-address'),
                placeholder: this.$t('enter-your-workplace-address'),
                model: 'workplace_address',
                styleClasses:'column ps-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('workplace_address');
                  } else {
                    this.removeBorder('workplace_address');
                  }
                },
              },
            ],
          },
          {
            fields: [
              {
                type: 'select',
                selectOptions: {
                  noneSelectedText: 'Select a country or region',
                },
                label: this.$t('network.auth.workplace_country') + '<sup class="text-danger ms-1">*</sup>',
                model: 'country',
                values: this.countries,
                styleClasses:'column pe-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('country');
                  } else {
                    this.removeBorder('country');
                  }
                },
              },
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('city-workplace') + '<sup class="text-danger ms-1">*</sup>',
                placeholder: this.$t('enter-your-city'),
                model: 'city',
                visible: function (model) {
                  return model && model.country != '193'; // 193 is the country code for United States
                },
                styleClasses:'column ps-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('city');
                  } else {
                    this.removeBorder('city');
                  }
                },
              },
              {
                type: 'select',
                selectOptions: {
                  noneSelectedText: 'Select a state',
                },
                label: this.$t('state-workplace') + '<sup class="text-danger ms-1">*</sup>',
                model: 'state',
                visible: function (model) {
                  return model && model.country == '193';
                },
                values: this.states,
                styleClasses:'column ps-3 mb-n4',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('state');
                  } else {
                    this.removeBorder('state');
                  }
                },
              },
            ],
          },
          {
            fields: [
              {
                type: 's3-upload',
                inputName: 'cv_file',
                label: this.$t('Investigator.cv-file'),
                model: 'cv_file',
                s3: { type: 'people' },
                onUploaded: () => {
                  // cause the form to be saved automatically (but not submitted)
                  this.save();
                },
                styleClasses:'columnFile',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('cv_file');
                  } else {
                    this.removeBorder('cv_file');
                  }
                },
              },
              {
                type: 'input',
                inputType: 'text',
                label: this.$t('cv-filename'),
                model: 'cv_filename',
                visible: function (model) {
                  return model && model.cv_file != null;
                },
                disabled: true,
                styleClasses:'column pe-3',
              },
              {
                type: 'input',
                inputType: 'date',
                format: 'YYYY-MM-DD',
                label: this.$t('auth.workinfo.cv_file_last_update_date'),
                model: 'cv_file_last_update_date',
                visible: function (model) {
                  return model && model.cv_file != null;
                },
                styleClasses:'column ps-3',
                onChanged: (model, newVal) => {
                  if (!newVal) {
                    this.addBorder('cv_file_last_update_date');
                  } else {
                    this.removeBorder('cv_file_last_update_date');
                  }
                },
              },
            ],
          }
        ],
      };
    },
  },
};
</script>
<style>
.vue-form-generator fieldset {
  margin-bottom: 1.5rem !important;
}
.vue-form-generator fieldset .form-control {
  width: 100% !important;
}
.column {
  float: left;
  width: 50%;
}
.columnFile {
  float: left;
  width: 100%;
}
</style>